// Lightweight device-platform classifier used to populate the user's
// `device_platforms` list on the backend. We use this to build the iOS
// waitlist so that on App Store launch day we can broadcast directly to
// iPhone users who registered via the web app.

import axios from 'axios';
import { isIOSDevice } from './iosInstallContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function getDevicePlatform() {
  try {
    if (typeof window === 'undefined' || !window.navigator) return 'desktop';
    if (isIOSDevice()) return 'ios';
    const ua = window.navigator.userAgent || '';
    if (/Android/i.test(ua)) return 'android';
    return 'desktop';
  } catch {
    return 'desktop';
  }
}

// Posts the detected device platform for the current user. Fire-and-forget:
// silently ignores errors so analytics tracking never blocks user flows.
// Idempotent — backend uses $addToSet so repeated calls are safe.
export async function recordDevicePlatform(token) {
  try {
    if (!token) return;
    await axios.post(
      `${API}/auth/device-platform`,
      { platform: getDevicePlatform() },
      { headers: { Authorization: `Bearer ${token}` } },
    );
  } catch {
    /* noop — never throw into the login flow */
  }
}
